/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * All possible Forbidden problems.
 */
export type ForbiddenProblems = Truvity.ForbiddenProblems.Forbidden;

export namespace ForbiddenProblems {
    export interface Forbidden extends Truvity.ProblemForbidden {
        type: '/forbidden';
    }
}
